import * as React from 'react';
import { useSelector } from 'react-redux';

// Utils
import { formatCents } from '@src/shared/src/util/general';
import { useTranslation } from 'react-i18next';
import { selectors } from '@src/shared/src';
import useBreakpoints from '@toolkit/util/useBreakpoints';
// Constants
// Actions
// Models
// Interfaces
// Components
import { Co2EmissionLabel } from '@src/components/Co2EmissionLabel';
// Styles
import '../styles/CheckoutFooter.scss';

type Props = React.PropsWithChildren & {
  totalPrice: number;
};

const CheckoutFooter: React.FC<Props> = ({ totalPrice, children }) => {
  const { t } = useTranslation();
  const { isMd } = useBreakpoints();
  const co2InKg = useSelector(selectors.checkout.basketCo2Total);

  return (
    <div className="checkout-footer">
      <div className="checkout-footer-wrapper">
        <div className="checkout-footer-total">
          {t('CheckoutFooter.label.totalBookable')}
          <div className="checkout-footer-price">{formatCents(totalPrice)}</div>
        </div>
        {isMd && <Co2EmissionLabel value={co2InKg} withIcon={false} isTotal textLeft />}
      </div>
      {children}
    </div>
  );
};

export default CheckoutFooter;
